import { graphql, useStaticQuery } from 'gatsby';

export const useBusinessInfoData = () => {
  const data = useStaticQuery(graphql`
    query {
      businessInfoDataJson {
        address
        email
      }
    }
  `);

  return data.businessInfoDataJson;
};
